/**
Author - Shreshtha Sharma
Git - https://github.com/shreshtha-wealthy
**/

import Carousel from "./Carousel.container";

export default Carousel;